import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=a4b3c820&scoped=true&"
import script from "./ImageLoader.vue?vue&type=script&lang=js&"
export * from "./ImageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b3c820",
  null
  
)

export default component.exports